module.exports = __webpack_public_path__ + "static/media/Lithium.f5cd2c10.jpg";